export default __webpack_public_path__ + "static/media/arrum-ayat-21.44f36e4c.mp3";